import { youtubeIcon, whatsappIcon, websiteIcon, venmoIcon, twitterIcon, twitchIcon, tiktokIcon, threadsIcon, spotifyIcon, snapchatIcon, pinterestIcon, linkedinIcon, instagramIcon, googleIcon, githubIcon, facebookIcon, etsyIcon, emailIcon, discordIcon, cash_appIcon, apple_podcastsIcon, apple_musicIcon, appleIcon, downloadIcon, addPaymentIcon, bankIcon, downIcon, upIcon, eyeIconCrossed, eyeIcon, checkMarkIcon, giftIcon, keepIcon, backIcon, picoIcon, closeIcon, paymentMethod, switchPlan, trashIcon, editIcon, logoutIcon, questionMarkIcon, refreshIcon, envelopeIcon, userIcon } from './customizableIcons.js';

var getSvgImage = function getSvgImage(color, iconType) {
  if (color === void 0) {
    color = '444';
  }
  if (iconType === void 0) {
    iconType = 'question-mark-icon';
  }
  switch (iconType) {
    case 'user-icon':
      return userIcon(color);
    case 'envelope-icon':
      return envelopeIcon(color);
    case 'refresh-icon':
      return refreshIcon(color);
    case 'question-mark-icon':
      return questionMarkIcon(color);
    case 'logout-icon':
      return logoutIcon(color);
    case 'edit-icon':
      return editIcon(color);
    case 'trash-icon':
      return trashIcon(color);
    case 'switch-plan':
      return switchPlan(color);
    case 'update-payment':
      return paymentMethod(color);
    case 'close-icon':
      return closeIcon(color);
    case 'pico-icon':
      return picoIcon(color);
    case 'back-icon':
      return backIcon(color);
    case 'keep-icon':
      return keepIcon(color);
    case 'gift-icon':
      return giftIcon(color);
    case 'check-icon':
      return checkMarkIcon(color);
    case 'eye-icon':
      return eyeIcon(color);
    case 'eye-icon-crossed':
      return eyeIconCrossed(color);
    case 'up-icon':
      return upIcon(color);
    case 'down-icon':
      return downIcon(color);
    case 'bank-icon':
      return bankIcon(color);
    case 'add-payment-icon':
      return addPaymentIcon(color);
    case 'download-icon':
      return downloadIcon(color);
    case 'apple-icon':
      return appleIcon();
    case 'apple_music-icon':
      return apple_musicIcon();
    case 'apple_podcasts-icon':
      return apple_podcastsIcon();
    case 'cash_app-icon':
      return cash_appIcon();
    case 'discord-icon':
      return discordIcon();
    case 'email-icon':
      return emailIcon();
    case 'etsy-icon':
      return etsyIcon();
    case 'facebook-icon':
      return facebookIcon();
    case 'github-icon':
      return githubIcon();
    case 'google-icon':
      return googleIcon();
    case 'instagram-icon':
      return instagramIcon();
    case 'linkedin-icon':
      return linkedinIcon();
    case 'pinterest-icon':
      return pinterestIcon();
    case 'snapchat-icon':
      return snapchatIcon();
    case 'spotify-icon':
      return spotifyIcon();
    case 'threads-icon':
      return threadsIcon();
    case 'tiktok-icon':
      return tiktokIcon();
    case 'twitch-icon':
      return twitchIcon();
    case 'twitter-icon':
      return twitterIcon();
    case 'venmo-icon':
      return venmoIcon();
    case 'website-icon':
      return websiteIcon();
    case 'whatsapp-icon':
      return whatsappIcon();
    case 'youtube-icon':
      return youtubeIcon();
    default:
      return null;
  }
};

export { getSvgImage as default };
//# sourceMappingURL=index.js.map
